<ng-content select="[mat-grid-avatar], [matGridAvatar]"></ng-content>
<div class="mat-grid-list-text"><ng-content select="[mat-line], [matLine]"></ng-content></div>
<ng-content></ng-content>
